import React, { useCallback, useImperativeHandle, useMemo, useState } from "react";

import { AppViewerDrawer } from "Components/Generic/AppViewerDrawer";
import { Member } from "Models/members/member";
import { useTranslation } from "react-i18next";

import { AvailabilitySection } from "./section/Availability";
import { CertificationSections } from "./section/Certifications";
import { DetailsSection } from "./section/Details";
import { TimeSheetSection } from "./section/Timesheet";
import { LoginSessions } from "./section/LoginSessions";

export interface MemberShowDrawerHandles {
  open: (member: Member) => void;
}

export const MemberShowDrawer = React.forwardRef<MemberShowDrawerHandles, any>((_props, ref) => {
  const [isOpenMemberShowDrawer, setIsOpenMemberShowDrawer] = useState<boolean>(false);
  const [member, setMember] = useState<Member>();
  const { t: translate } = useTranslation();

  const title = useMemo(() => {
    if (!member) return;

    return `${translate("view")} ‘${member.fullName}’`;
  }, [member]);

  const open = useCallback((member: Member) => {
    setMember(member);
    setIsOpenMemberShowDrawer(true);
  }, []);

  const close = useCallback(() => {
    setIsOpenMemberShowDrawer(false);
  }, []);

  useImperativeHandle(ref, () => ({
    open,
    close,
  }));

  const sections = [
    {
      id: "details",
      title: translate("details"),
      content: member && <DetailsSection member={member} />,
    },
    {
      id: "availability",
      title: translate("availability"),
      content: member && <AvailabilitySection member={member} />,
    },
    {
      id: "timesheet",
      title: translate("timesheet"),
      content: member && <TimeSheetSection member={member} />,
    },
    {
      id: "certifications",
      title: translate("certifications"),
      content: member && <CertificationSections member={member} />,
    },
    {
      id: "sessions",
      title: translate("activeLoginSessions"),
      content: member && <LoginSessions member={member} />,
    },
  ];

  return (
    <AppViewerDrawer
      DrawerProps={{
        open: isOpenMemberShowDrawer,
        onClose: close,
      }}
      title={title}
      fullHeight
      sectionItems={sections}
    />
  );
});
